import Vue from 'vue'
import configs from '@/config'
import store from '@/vuex/store'
import Constants from '@/constant'
import SystemConnection, { CONNECTION_STATUS } from '@/utils/system/SystemConnection'

let resource = null

const actions = {
  clearPresentationData: {
    method: 'POST',
    url: `${configs.baseUrl}/api/presentation/clear-data-audience/`,
  },
  /**
   * TODO:
   * `clearPresentationDataViaProxy` is identical to `clearPresentationData` for now
   * later when we switch this end-point to liveProxy,
   * baseUrl should be changed to liveProxyUrl
   */
  clearPresentationDataViaProxy: {
    method: 'POST',
    url: `${configs.baseUrl}/api/presentation/clear-data-audience/`,
  },
  createNewPresentation: {
    method: 'POST',
    url: `${configs.baseUrl}/api/presentation/create/`,
  },
  getPresentations: {
    method: 'GET',
    url: `${configs.baseUrl}/api/presentation/list/infinity-scroll/`,
  },
  getPresentationsInfinityScrollV2: {
    method: 'GET',
    url: `${configs.baseUrl}/api/presentation/list/infinity-scroll/v2`,
  },
  searchPresentations: {
    method: 'GET',
    url: `${configs.baseUrl}/api/presentation/search`,
  },
  getHomePresentations: {
    method: 'GET',
    url: `${configs.baseUrl}/api/presentation/list/home`,
  },
  getSharedPresentations: {
    method: 'GET',
    url: `${configs.baseUrl}/api/presentation/shared-presentations/`,
  },
  getDemoPresentationBySourcePresentationId: {
    method: 'POST',
    url: `${configs.baseSupportUrl}/api/presentation/{presentationId}/demo`,
  },
  patchPresentation: {
    method: 'PATCH',
    url: `${configs.baseUrl}/api/presentation/{presentationId}`,
  },
  restoreFromTrash: {
    method: 'POST',
    url: `${configs.baseUrl}/api/presentation/recover-from-trash`,
  },
  permanentlyDelete: {
    method: 'PATCH',
    url: `${configs.baseUrl}/api/presentation/permanently-delete/`,
  },
  getPresentationsV2: {
    method: 'GET',
    url: `${configs.baseUrl}/api/presentation/`,
  },
  getPresentationsFromTrash: {
    method: 'GET',
    url: `${configs.baseUrl}/api/presentation/trash`,
  },
  patchPresentations: {
    method: 'PATCH',
    url: `${configs.baseUrl}/api/presentation/`,
  },
  deletePresentations: {
    method: 'DELETE',
    url: `${configs.baseUrl}/api/presentation/`,
  },
  updatePresentationByPresentationId: {
    method: 'PUT',
    url: `${configs.baseUrl}/api/presentation/update/{presentationId}`,
  },
  updateOnlineCountByPresentationId: {
    method: 'POST',
    url: `${configs.baseUrl}/api/presentation/update-online-count/{presentationId}`,
  },
  getSharedUsers: {
    method: 'GET',
    url: `${configs.baseUrl}/api/presentation/{presentationId}/shared-users`,
  },
  sendPresentationCopy: {
    method: 'POST',
    url: `${configs.baseUrl}/api/presentation/{presentationId}/share`,
  },
  generateModerationCode: {
    method: 'POST',
    url: `${configs.baseUrl}/api/presentation/{presentationId}/generate-moderation-code`,
  },
  changeAccessCode: {
    method: 'PUT',
    url: `${configs.baseUrl}/api/presentation/change-access-code/{presentationId}`,
  },
  addCollaborators: {
    method: 'POST',
    url: `${configs.baseUrl}/api/presentation/{presentationId}/collaborators`,
  },
  getCollaborators: {
    method: 'GET',
    url: `${configs.baseUrl}/api/presentation/{presentationId}/collaborators`,
  },
  removeCollaborators: {
    method: 'DELETE',
    url: `${configs.baseUrl}/api/presentation/{presentationId}/collaborators`,
  },
  leaveCollaborators: {
    method: 'DELETE',
    url: `${configs.baseUrl}/api/presentation/{presentationId}/collaborators/leave`,
  },
  changePresentationCollaboratorRole: {
    method: 'PATCH',
    url: `${configs.baseUrl}/api/presentation/{presentationId}/collaborators`,
  },
  takeOver: {
    method: 'POST',
    url: `${configs.baseUrl}/api/presentation/{presentationId}/take-over/`,
  },
  getTakenOverBy: {
    method: 'GET',
    url: `${configs.baseUrl}/api/presentation/{presentationId}/take-over/`,
  },
  getAudienceOnline: {
    method: 'POST',
    url: `${configs.baseUrl}/api/presentation/count-audience/`,
  },
  getTemplates: {
    method: 'GET',
    url: `${configs.baseSupportUrl}/api/presentation/templates/`,
  },
  getNewTemplates: {
    method: 'GET',
    url: `${configs.baseSupportUrl}/api/presentation/new-templates/`,
  },
  getTemplatesAdminPicked: {
    method: 'GET',
    url: `${configs.baseSupportUrl}/api/presentation/templates-admin-picked`,
  },
  copyTemplateToAccount: {
    method: 'POST',
    url: `${configs.baseUrl}/api/presentation/templates/copy-to-account/`,
  },
  copyPresentationToAccountByShareCode: {
    method: 'POST',
    url: `${configs.baseUrl}/api/presentation/copy-presentation/`,
  },
  getPresentationBasic: {
    method: 'GET',
    url: `${configs.baseUrl}/api/presentation/basic/{presentationId}`,
  },
  generateReport: {
    method: 'POST',
    url: `${configs.baseUrl}/api/presentation/generate-report/{presentationId}`,
  },
  // For shared report only
  //-----------------------
  getPresentationFlagInfoBySharedToken: {
    method: 'GET',
    url: `${configs.baseUrl}/api/presentation/shared-report/feature-flags/{sharedToken}`,
  },
  getPresentationDetailBySharedToken: {
    method: 'GET',
    url: `${configs.baseUrl}/api/presentation/detail-for-shared-report/{sharedToken}`,
  },
  generateSharedReport: {
    method: 'POST',
    url: `${configs.baseUrl}/api/presentation/generate-report-shared/{sharedToken}`,
  },
  getSharedReport: {
    method: 'POST',
    url: `${configs.baseUrl}/api/presentation/{sharedToken}/shared-report/v2/generate`,
  },
  getSharedReportPrivateFeedbacks: {
    method: 'GET',
    url: `${configs.baseUrl}/api/private-feedbacks/shared-report/{sharedToken}`,
  },
  getSharedReportToken: {
    method: 'GET',
    url: `${configs.baseUrl}/api/presentation/{presentationId}/report-share-token`,
  },
  resetSharedReportToken: {
    method: 'POST',
    url: `${configs.baseUrl}/api/presentation/{presentationId}/report-share-token/reset`,
  },
  // ------------------------
  getReport: {
    method: 'POST',
    url: `${configs.baseUrl}/api/presentation/{presentationId}/report/v2/generate`,
  },
  getPresentationById: {
    method: 'GET',
    url: `${configs.baseUrl}/api/presentation/basic/{presentationId}`,
  },
  getPresentationPlayDemo: {
    method: 'POST',
    url: `${configs.baseUrl}/api/users/{userId}/get-demo-presentation/`,
  },

  getYearWrapUp: {
    method: 'GET',
    url: `${configs.baseUrl}/api/presentation/wrapped-up`,
  },

  uploadScreenshot: {
    method: 'POST',
    url: `${configs.baseUrl}/api/presentation/wrapped-up/upload-screenshot`,
  },
  countHostedEvents: {
    method: 'GET',
    url: `${configs.baseUrl}/api/presentation/count-hosted-events`,
  },
  updatePresentationRequest: {
    method: 'POST',
    url: `${configs.baseUrl}/api/presentation/{presentationId}/request`,
  },
  importDocument: {
    method: 'POST',
    url: `${configs.baseUrl}/api/presentation/import-document/`,
  },
  openPrivateFeedback: {
    method: 'POST',
    url: `${configs.baseUrl}/api/presentation/{presentationId}/open-private-feedback/`,
  },
  updateParticipantFields: {
    method: 'PATCH',
    url: `${configs.baseUrl}/api/presentation/{presentationId}/participant-fields/`,
  },
  updateSelectedParticipantFields: {
    method: 'PATCH',
    url: `${configs.baseUrl}/api/presentation/{presentationId}/selected-participant-fields/`,
  },
  getPrivateFeedbacks: {
    method: 'GET',
    url: `${configs.baseUrl}/api/private-feedbacks/{presentationId}`,
  },
  getPresentationDetails: {
    method: 'GET',
    url: `${configs.baseUrl}/api/presentation/detail/{presentationId}`,
  },
  getPresentationDetailsV2: {
    method: 'GET',
    url: `${configs.baseUrl}/api/presentation/detail/v2/{presentationId}`,
  },
  getPresentationDetailsByShareCode: {
    method: 'GET',
    url: `${configs.baseUrl}/api/presentation/share-presentation/{presentationId}`,
  },
  getPresentationLiteByShareCode: {
    method: 'GET',
    url: `${configs.baseUrl}/api/presentation/share-lite/{presentationId}`,
  },
  requestAccessPresentation: {
    method: 'POST',
    url: `${configs.baseUrl}/api/access-request/`,
  },
  getPresentationFlagInfo: {
    method: 'GET',
    url: `${configs.baseUrl}/api/presentation/feature-flag-infos/by-id/{presentationId}`,
  },
  getPresentationFlagInfoByShareCode: {
    method: 'GET',
    url: `${configs.baseUrl}/api/presentation/feature-flag-infos/by-share-code/{shareCode}`,
  },
  generateRemoteAccessCode: {
    method: 'POST',
    url: `${configs.baseUrl}/api/remote-control/presentation/{presentationId}/generate-access-code`,
  },
  revokeRemoteAccessCode: {
    method: 'POST',
    url: `${configs.baseUrl}/api/remote-control/presentation/{presentationId}/revoke-access-code`,
  },
  movePresentations: {
    method: 'POST',
    url: `${configs.baseUrl}/api/presentation/move-to`,
  },
  getRootPresentationUpdateTime: {
    method: 'GET',
    url: `${configs.baseUrl}/api/presenting-sessions/shared-presentations/{presentationId}/root-presentation-update-time`,
  },
  syncWithRootPresentation: {
    method: 'PATCH',
    url: `${configs.baseUrl}/api/presenting-sessions/shared-presentations/{presentationId}/sync-with-root-presentation`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const clearPresentationData = async (params) => {
  await resource.clearPresentationData(params)
}

const createNewPresentation = async (params) => {
  const res = await resource.createNewPresentation(params)
  return res.body
}

const getPresentations = async (params) => {
  const useLastEdit = store.getters['presentationsModule/canUseLastEditTimestamp']
  let res
  if (useLastEdit) {
    if (params?.sortColumn === 'updatedAt') {
      params = {
        ...params,
        sortColumn: 'lastEditedAt',
      }
    }
    res = await resource.getPresentationsInfinityScrollV2(params)
  } else {
    res = await resource.getPresentations(params)
  }
  // backward compatible
  // about to change the property "result" into "presentations"
  res.body.presentations = res.body.result || res.body.presentations

  return res.body
}

const searchPresentations = async (params) => {
  const res = await resource.searchPresentations(params)
  res.body.presentations = res.body.result || res.body.presentations
  return res.body
}

const getSharedPresentations = async (params) => {
  const res = await resource.getSharedPresentations(params)

  return res.body
}
const getDemoPresentationBySourcePresentationId = async (presentationId, params) => {
  const res = await resource.getDemoPresentationBySourcePresentationId({ presentationId }, params)
  return res.body.presentation
}

const patchPresentations = async (params) => {
  const res = await resource.patchPresentations(params)

  return {
    presentations: res.body.presentations,
  }
}

const deletePresentations = async (presentationIds) => {
  return resource.deletePresentations(null, {
    presentationIds,
  })
}

const updatePresentationByPresentationId = async (presentationId, params) => {
  try {
    return await resource.updatePresentationByPresentationId({ presentationId }, params)
  } catch (error) {
    SystemConnection.detectGeneralConnection(CONNECTION_STATUS.UNSTABLE)
    return { body: { error: error.message } }
  }
}

const updateOnlineCountByPresentationId = (presentationId, params) => {
  return resource.updateOnlineCountByPresentationId({ presentationId }, params)
}

const patchPresentation = (presentationId, params) => {
  return resource.patchPresentation({ presentationId }, params)
}

const getTakenOverBy = (presentationId, params) => {
  return resource.getTakenOverBy({ presentationId }, params)
}

const getSharedUsers = async (presentationId) => {
  const res = await resource.getSharedUsers({ presentationId })

  return res.body.data
}

const sendPresentationCopy = (presentationId, params = {}) => {
  return resource.sendPresentationCopy({ presentationId }, params)
}

const changeAccessCode = (presentationId, params = {}) => {
  return resource.changeAccessCode({ presentationId }, params)
}

const generateModerationCode = async (presentationId, params) => {
  const res = await resource.generateModerationCode({ presentationId }, params)
  return res.body.moderationCode
}

const addCollaborators = async (presentationId, { limitedInviteToEdit, ...params }) => {
  const queryParams = {}
  if (limitedInviteToEdit !== undefined) {
    queryParams.limitedInviteToEdit = limitedInviteToEdit
  }

  const res = await resource.addCollaborators({ presentationId, ...queryParams }, params)
  return res.body
}

const removeCollaborators = async (presentationId, params) => {
  const res = await resource.removeCollaborators({ presentationId }, params)
  return res.body
}

const leaveCollaborators = async (presentationId, params) => {
  const res = await resource.leaveCollaborators({ presentationId }, params)
  return res.body
}

const getCollaborators = async (presentationId, params) => {
  const res = await resource.getCollaborators({ presentationId }, params)
  return res.body
}

const changePresentationCollaboratorRole = async (presentationId, params) => {
  const res = await resource.changePresentationCollaboratorRole({ presentationId }, params)

  return res.body
}

const takeOver = async (presentationId, params) => {
  const res = await resource.takeOver({ presentationId }, params)
  return res.body
}

const getAudienceOnline = async (params) => {
  try {
    if (store.getters['featureToggles/canUseEveryoneHasAnswered']) {
      await store.dispatch('resetCountingEveryoneHasAnswered')
    }
  } catch (error) {
    // do nothing
  }
  const res = await resource.getAudienceOnline(params)
  return res.body
}

const getTemplates = async (params) => {
  const res = await resource.getTemplates(params)
  return res.body
}

const getTemplatesAdminPicked = async () => {
  const res = await resource.getTemplatesAdminPicked()
  return res.body
}

const getNewTemplates = async (params) => {
  const res = await resource.getNewTemplates(params)
  return res.body
}

const copyTemplateToAccount = async (params) => {
  const res = await resource.copyTemplateToAccount(params)
  return res.body
}

const getPresentationBasic = async (presentationId) => {
  const res = await resource.getPresentationBasic({ presentationId })
  return res.body
}

const getPresentationById = async (presentationId) => {
  const res = await resource.getPresentationById({ presentationId })
  return res.body
}

const generateReport = async (presentationId) => {
  const res = await resource.generateReport({ presentationId }, null)
  return res.body
}
const getReport = async (presentationId, params) => {
  const res = await resource.getReport({ presentationId }, { ...params })
  return res.body
}

const getPresentationPlayDemo = async (userId, params) => {
  const res = await resource.getPresentationPlayDemo({ userId }, params)
  return res.body.presentation
}

const getYearWrapUp = async () => {
  const res = await resource.getYearWrapUp()
  return res.body
}

const uploadScreenshot = async (params) => {
  const res = await resource.uploadScreenshot(null, params)
  return res.body
}

const countHostedEvents = async () => {
  const res = await resource.countHostedEvents()
  if (res.body && res.body.numberOfHostedPresentations) {
    return res.body.numberOfHostedPresentations
  }
  return 0
}

const updatePresentationRequest = (presentationId, params) => {
  return resource.updatePresentationRequest({ presentationId }, params)
}

const importDocument = (params) => {
  return resource.importDocument(params)
}

const openPrivateFeedback = (presentation) => {
  return resource.openPrivateFeedback({ presentationId: presentation.id }, {
    uniqueAccessCode: presentation.uniqueAccessCode,
  })
}

const getPrivateFeedbacks = async (presentationId) => {
  const res = await resource.getPrivateFeedbacks({ presentationId })

  return res.body
}

const getPresentationDetails = async (presentationId, params = null) => {
  let res = null
  if (store.getters['aiChatbot/canOffAiBotMessagesInPresentationDetail']) {
    params = { ...params, ...{ skipAiBotMessages: true } }
  }
  if (store.getters['multipleSessions/canInvitePresenterToFolder']) {
    params = { ...params, batchShareAsPresenter: true }
  }
  if (store.getters['liveStatsV2/canUseWordCloudEmqx']) {
    res = await resource.getPresentationDetailsV2({ presentationId, ...params })
  } else {
    res = await resource.getPresentationDetails({ presentationId, ...params })
  }

  res.body.Slides?.forEach((slide) => {
    if (slide.type === Constants.SLIDE_TYPE.PICK_ANSWER && !slide.slideType) {
      slide.slideType = Constants.SLIDE_TYPE.PICK_IMAGE
    }
  })
  return res
}

const getPresentationDetailsByShareCode = async (presentationId, params = null) => {
  let res = null
  if (store.getters['presentationsModule/canSharePublicOnly']) {
    params = params ? { ...params, publicOnly: true } : params
  }
  if (store.getters['liveStatsV2/canUseWordCloudEmqx']) {
    res = await resource.getPresentationLiteByShareCode({ presentationId, ...params })
  } else {
    res = await resource.getPresentationDetailsByShareCode({ presentationId, ...params })
  }

  return res
}

const getPresentationFlagInfo = async (presentationId, params = null) => {
  return resource.getPresentationFlagInfo({ presentationId, ...params })
}

const getPresentationFlagInfoByShareCode = async (shareCode, params = null) => {
  return resource.getPresentationFlagInfoByShareCode({ shareCode, ...params })
}

const getHomePresentations = async (params = {}) => {
  const res = await resource.getHomePresentations(params)
  return res.body
}

const getPresentationsV2 = async (params) => {
  const res = await resource.getPresentationsV2(params)
  return res.body
}

const getPresentationsFromTrash = async (params) => {
  const res = await resource.getPresentationsFromTrash(params)
  return res.body
}

const restoreFromTrash = async (params) => {
  const res = await resource.restoreFromTrash(params)
  return res.body
}

const permanentlyDelete = async (params) => {
  const res = await resource.permanentlyDelete(params)
  return res.body
}

const requestAccessPresentation = ({ presentationId }) => {
  return resource.requestAccessPresentation({ presentationId })
}

const generateRemoteAccessCode = async ({ presentationId }) => {
  const res = await resource.generateRemoteAccessCode({ presentationId }, {})
  return res.body
}

const revokeRemoteAccessCode = async ({ presentationId }) => {
  const res = await resource.revokeRemoteAccessCode({ presentationId }, {})
  return res.body
}

const movePresentations = async (params) => {
  return resource.movePresentations(params)
}

const getRootPresentationUpdateTime = async (presentationId) => {
  const res = await resource.getRootPresentationUpdateTime({ presentationId })
  return res.body
}

const syncWithRootPresentation = async (presentationId) => {
  const res = await resource.syncWithRootPresentation({ presentationId }, {})
  return res.body
}

const updateParticipantFields = async (presentationId, payload) => {
  const res = await resource.updateParticipantFields({ presentationId }, payload)
  return res.body
}

const updateSelectedParticipantFields = async (presentationId, payload) => {
  const res = await resource.updateSelectedParticipantFields({ presentationId }, payload)
  return res.body
}

// For shared report only
//-----------------------
const getPresentationFlagInfoBySharedToken = async (sharedToken) => {
  const res = await resource.getPresentationFlagInfoBySharedToken({ sharedToken })
  return res.body
}

const getSharedReportToken = async (presentationId) => {
  const res = await resource.getSharedReportToken({ presentationId })
  return res.body
}

const resetSharedReportToken = async (presentationId) => {
  const res = await resource.resetSharedReportToken({ presentationId }, null)
  return res.body
}

const getPresentationDetailBySharedToken = async (sharedToken, params) => {
  const res = await resource.getPresentationDetailBySharedToken({ sharedToken, ...params })
  return res.body
}

const generateSharedReport = async (sharedToken) => {
  const res = await resource.generateSharedReport({ sharedToken }, null)
  return res.body
}

const getSharedReport = async (sharedToken, params) => {
  const res = await resource.getSharedReport({ sharedToken }, { ...params })
  return res.body
}

const getSharedReportPrivateFeedbacks = async (sharedToken) => {
  const res = await resource.getSharedReportPrivateFeedbacks({ sharedToken })

  return res.body
}

const copyPresentationToAccountByShareCode = async (params) => {
  const res = await resource.copyPresentationToAccountByShareCode(params)
  return res.body
}
// ------------------------

export default {
  patchPresentation,
  clearPresentationData,
  createNewPresentation,
  deletePresentations,
  getPresentations,
  searchPresentations,
  getSharedPresentations,
  getDemoPresentationBySourcePresentationId,
  initResource,
  patchPresentations,
  updatePresentationByPresentationId,
  getSharedUsers,
  sendPresentationCopy,
  generateModerationCode,
  changeAccessCode,
  addCollaborators,
  getCollaborators,
  removeCollaborators,
  leaveCollaborators,
  changePresentationCollaboratorRole,
  takeOver,
  getAudienceOnline,
  getTakenOverBy,
  getTemplates,
  getTemplatesAdminPicked,
  copyTemplateToAccount,
  getPresentationBasic,
  generateReport,
  getReport,
  getPresentationById,
  getPresentationPlayDemo,
  getYearWrapUp,
  uploadScreenshot,
  countHostedEvents,
  updatePresentationRequest,
  importDocument,
  updateOnlineCountByPresentationId,
  openPrivateFeedback,
  getPrivateFeedbacks,
  getPresentationDetails,
  getHomePresentations,
  getNewTemplates,
  getPresentationsV2,
  getPresentationsFromTrash,
  restoreFromTrash,
  permanentlyDelete,
  requestAccessPresentation,
  getPresentationFlagInfo,
  getPresentationFlagInfoByShareCode,
  getPresentationDetailsByShareCode,
  generateRemoteAccessCode,
  revokeRemoteAccessCode,
  movePresentations,
  getRootPresentationUpdateTime,
  syncWithRootPresentation,
  updateParticipantFields,
  updateSelectedParticipantFields,
  getSharedReportToken,
  resetSharedReportToken,
  getPresentationDetailBySharedToken,
  getSharedReport,
  generateSharedReport,
  getSharedReportPrivateFeedbacks,
  getPresentationFlagInfoBySharedToken,
  copyPresentationToAccountByShareCode,
}
